import { render } from "./ImportUserResultForm.vue?vue&type=template&id=af36dc72&scoped=true&ts=true"
import script from "./ImportUserResultForm.vue?vue&type=script&lang=ts"
export * from "./ImportUserResultForm.vue?vue&type=script&lang=ts"

import "./ImportUserResultForm.vue?vue&type=style&index=0&id=af36dc72&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af36dc72"]])

export default __exports__